export default __webpack_public_path__ + "static/media/chooseField.31688e85.png";